<div class="relative inline-flex">
  @if (period() === ChartRangeOptions.Week) {
    <div class="absolute top-0 left-0 w-0 h-0 overflow-hidden">
      <mat-date-range-input [rangePicker]="weekDp" [max]="maxDate">
        <input
          matStartDate
          [formControl]="weekDateStart"
          (dateChange)="onWeekStartChanged($event)"
        />
        <input matEndDate [formControl]="weekDateEnd" />
      </mat-date-range-input>
      <mat-date-range-picker #weekDp></mat-date-range-picker>
    </div>
    <div
      class="inline-flex items-center overflow-hidden"
      [class]="
        framed()
          ? 'rounded-lg border border-border-card bg-surface-card p-1'
          : 'rounded-md border border-gray-300 bg-white'
      "
    >
      <button
        type="button"
        class="px-2 py-1.5 hover:bg-gray-50 transition-colors cursor-pointer"
        (click)="prev()"
      >
        <mat-icon [class.text-text-secondary]="framed()" class="!text-base !w-5 !h-5 !leading-5"
          >chevron_left</mat-icon
        >
      </button>
      @if (!framed()) {
        <div class="w-px h-5 bg-gray-200"></div>
      }
      <button
        type="button"
        class="flex items-center gap-1.5 px-3 py-1.5 text-sm hover:bg-gray-50 transition-colors cursor-pointer"
        (click)="weekDp.open()"
      >
        <mat-icon class="!text-base !w-5 !h-5 !leading-5 text-primary">calendar_today</mat-icon>
        <span [class.font-semibold]="framed()">{{ displayDate }}</span>
        <mat-icon class="!text-base !w-5 !h-5 !leading-5 text-gray-500">arrow_drop_down</mat-icon>
      </button>
      @if (!framed()) {
        <div class="w-px h-5 bg-gray-200"></div>
      }
      <button
        type="button"
        class="px-2 py-1.5 hover:bg-gray-50 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        (click)="next()"
        [disabled]="isNextDisabled()"
      >
        <mat-icon [class.text-text-secondary]="framed()" class="!text-base !w-5 !h-5 !leading-5"
          >chevron_right</mat-icon
        >
      </button>
    </div>
  } @else {
    <input
      class="absolute top-0 left-0 w-0 h-0 opacity-0"
      [matDatepicker]="dp"
      [formControl]="date"
      [max]="maxDate"
      (dateChange)="onDateChanged()"
    />
    <mat-datepicker
      #dp
      [startView]="datepickerStartView"
      [panelClass]="datepickerPanelClass"
      (monthSelected)="onMonthSelected($event, dp)"
      (yearSelected)="onYearSelected($event, dp)"
    >
    </mat-datepicker>
    <div
      class="inline-flex items-center overflow-hidden"
      [class]="
        framed()
          ? 'rounded-lg border border-border-card bg-surface-card p-1'
          : 'rounded-md border border-gray-300 bg-white'
      "
    >
      <button
        type="button"
        class="px-2 py-1.5 hover:bg-gray-50 transition-colors cursor-pointer"
        (click)="prev()"
      >
        <mat-icon [class.text-text-secondary]="framed()" class="!text-base !w-5 !h-5 !leading-5"
          >chevron_left</mat-icon
        >
      </button>
      @if (!framed()) {
        <div class="w-px h-5 bg-gray-200"></div>
      }
      <button
        type="button"
        class="flex items-center gap-1.5 px-3 py-1.5 text-sm hover:bg-gray-50 transition-colors cursor-pointer"
        (click)="dp.open()"
      >
        <mat-icon class="!text-base !w-5 !h-5 !leading-5 text-primary">calendar_today</mat-icon>
        <span [class.font-semibold]="framed()">{{ displayDate }}</span>
        <mat-icon class="!text-base !w-5 !h-5 !leading-5 text-gray-500">arrow_drop_down</mat-icon>
      </button>
      @if (!framed()) {
        <div class="w-px h-5 bg-gray-200"></div>
      }
      <button
        type="button"
        class="px-2 py-1.5 hover:bg-gray-50 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        (click)="next()"
        [disabled]="isNextDisabled()"
      >
        <mat-icon [class.text-text-secondary]="framed()" class="!text-base !w-5 !h-5 !leading-5"
          >chevron_right</mat-icon
        >
      </button>
    </div>
  }
</div>
